<template lang='pug'>
  v-app
    v-app-bar(color="#005cb8" flat dense app)
      a(href="https://arlingtonva.us" aria-label="Arlington VA - Home").d-none.d-md-block.mx-2
        v-img.my-auto(max-height="38" max-width="220" position="top, left" src="https://www.arlingtonva.us/files/oc-templates/00000000-0000-0000-0000-000000000000/48e205af-32b5-43fa-97d5-785a9f23ed57/arlington-logo.svg?t=637703207315439537")
      v-spacer.d-none.d-md-block
      .d-flex(v-if="isAuthenticated")
        season-module.my-auto.mr-4
        coach-module.my-auto.mr-4.d-none.d-md-block
      v-spacer
      .d-flex
        v-btn(text color="white" :to="{name: 'login'}" title="Login" v-if="!isAuthenticated") Login
        v-btn(text color="white" :to="{name: 'logout'}" title="Logout" v-if="isAuthenticated") Logout
    v-content
      router-view
    v-footer(color="#005cb8")
      p.ma-auto.white--text.body-2 Copyright © {{new Date().getFullYear()}} Arlington County Virginia
</template>

<script>
import Vue from "vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { mapGetters, mapState } from "vuex";
import CoachModule from '@/components/CoachModule.vue'
import SeasonModule from '@/components/SeasonModule.vue'
import VPromiseBtn from '@/components/VPromiseBtn.vue'

export default Vue.extend({
  components: {
    VPromiseBtn,
    CoachModule,
    SeasonModule
  },
  data: () => ({}),
  mounted() {

  },
  methods: {},
  computed: {
    ...mapGetters(["isAuthenticated","season"]),
    ...mapState({
      coach: state => state.main.coach
    })
  }
});
</script>

<style lang="sass">
.v-list-item__title
  color: black

// Fix contrast for Vuetify placeholder/label text (and when Google Translate wraps it in .notranslate).
// Vuetify default uses rgba(0,0,0,0.38) which fails WCAG AA; override to meet 4.5:1 on white.
.v-application .v-label,
.v-application .v-input input::placeholder,
.v-application span.notranslate
  color: rgba(0, 0, 0, 0.72) !important
</style>
